﻿import { Decorators } from "@serenity-is/corelib";

export enum DataAuditLogType {
    Insert = 1,
    Update = 2,
    Delete = 3
}
Decorators.registerEnumType(DataAuditLogType, 'Serenity.Pro.DataAuditLog.DataAuditLogType');